import { useEffect, useRef } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { SortGuids } from "../../../../utilities/rhfdatanormalizationfunctions";
import useApi from "../../../../hooks/use-api";
import useMessageStore from "../../../../stores/message-store";

const DEFAULT_FUNDING_TYPE_OTHER = '';

const FundingTypesNew = ({ApplicationID,FundingTypes = [],formValues,ResetSelectedFundingTypes}) => {
    const initialValues = {
        fundingtypes: [],
        fundingtypeother: DEFAULT_FUNDING_TYPE_OTHER
    }

    const {handleSubmit,register,control,watch,resetField,reset,formState: {isDirty,isSubmitting}} = useForm({defaultValues: initialValues});
    const previousHasFollowup = useRef(false);
    
    const {patchRequest} = useApi();

    const addToast = useMessageStore(state => state.addToast);

    const _onSubmit = async(values) => {
        const sendObject = {
            ApplicationID: ApplicationID,
            Types: values.fundingtypes,
            TypesOther: values.fundingtypeother === '' ? null : values.fundingtypeother
        };

        const [,status] = await patchRequest('UpdateHousingFundingTypes',sendObject);

        if(status === 200)
        {
            ResetSelectedFundingTypes(values);

            addToast(
                {
                    id: Math.random(),
                    body: "The Funding Types were succesfully updated!",
                    autoHide: true,
                    errorFlag: false,
                    timestamp: Date.now() - 1000
                }
            );
        }
        else{
            addToast(
                {
                    id: Math.random(),
                    body: "A problem occured when updating the Funding Types.",
                    autoHide: true,
                    errorFlag: true,
                    timestamp: Date.now() - 1000
                }
            );
        }
    }

    useEffect(() => {
        if(!formValues){
            return;
        }

        const resetVal = {
            ...formValues,
            fundingtypes: [...(formValues.fundingtypes ?? [])].sort(SortGuids),
            fundingtypeother: formValues.fundingtypeother ?? DEFAULT_FUNDING_TYPE_OTHER
        }

        reset(resetVal);
    },[formValues,reset])

    const colLength = Math.ceil(FundingTypes.length / 3);
    const fundingColumns = Array.from({length: 3},(_,i) => FundingTypes.slice(i * colLength,(i + 1) * colLength));


    const fundingTypes = watch('fundingtypes');
    const hasFollowup = FundingTypes.some(fundingType => fundingTypes.includes(fundingType.id) && fundingType.hasfollowup);

    useEffect(() => {
        if(previousHasFollowup.current && !hasFollowup){
            resetField('fundingtypeother',{defaultValue: DEFAULT_FUNDING_TYPE_OTHER});
        }

        previousHasFollowup.current = hasFollowup;
    },[hasFollowup,resetField])

    return(
        <form onSubmit={handleSubmit(_onSubmit)}>
            <fieldset>
                <legend className="fw-bold" style={{fontSize: '1rem',marginBottom: '0'}}>Client Received Housing Supplement Funding Type</legend>
                <Controller
                    control={control}
                    name="fundingtypes"
                    render={({field}) => (
                        <Row>
                            {
                                fundingColumns.map((col,colIndex) => (
                                    <Col xs={12} md={4} key={colIndex}>
                                        {col.map((fundingType) => (
                                            <div key={fundingType.id}>
                                                <label>
                                                    <input type="checkbox" value={fundingType.id} checked={field.value.includes(fundingType.id)}
                                                        onChange={(e) => {
                                                            const value = e.target.value;

                                                            if(e.target.checked){
                                                                field.onChange([...field.value,value].sort(SortGuids));
                                                            }
                                                            else{
                                                                field.onChange(field.value.filter((id) => id !== value));
                                                            }
                                                        }} 
                                                    />
                                                    {fundingType.name}
                                                </label>
                                            </div>
                                        ))}
                                    </Col>
                                ))
                            }
                        </Row>
                    )}
                />
            </fieldset>
            {
                hasFollowup
                && 
                <div className="mt-2 mb-2">
                    <label htmlFor="fundingtypeother">Funding Type (Other)</label>
                    <input type="text" id="fundingtypeother" {...register('fundingtypeother')} style={{width: '100%'}} />
                </div>
            }
            <div className="d-flex justify-content-end">
                <Button type="submit" variant="primary" disabled={!isDirty || isSubmitting}>
                    Save Changes
                </Button>
            </div>
        </form>
    )
}

export default FundingTypesNew;
